import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "border", "borderRadius", "background", "padding"],
  _excluded2 = ["children"];
import { forwardRef } from 'react';
import { LayoutBox } from './LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayoutTile = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      border = 'border',
      borderRadius = 'border-radius',
      background = 'background-color-light',
      padding = 'space-md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    background: background,
    border: border,
    borderRadius: borderRadius,
    padding: padding,
    ref: ref,
    children: children
  }));
});
export const LayoutTileTinted = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(LayoutTile, Object.assign({}, rest, {
    background: "background-color",
    ref: ref,
    children: children
  }));
});